export default function useEventStream(config) {
    config = Object.assign(
        {
            streamId: null,
            eventName: 'update',
            reopenAfterCompleted: false,
            closeAfterHiddenFor: null,
            onMessage: () => {},
            onComplete: () => {},
            onError: () => {},
        },
        config
    );

    let eventSource = null;
    let streamId = config.streamId;
    let messages = [];
    let visibilitychangeTimeoutId = 0;

    const streamIdListener = (event) => (streamId = event.data);

    const messageListener = (event) => {
        if (event.data === '<stream>' || event.data === '<ping>') {
            return;
        } else if (event.data === '</stream>') {
            closeConnection();
            config.onComplete();

            if (config.reopenAfterCompleted) {
                openConnection();
            }

            return;
        }

        messages.push(event.data);
        config.onMessage(event);
    };

    const errorListener = (event) => {
        config.onError(event);
        closeConnection();
    };

    const visibilitychangeListener = () => {
        if (config.closeAfterHiddenFor === null) return;

        if (document.hidden) {
            visibilitychangeTimeoutId = window.setTimeout(() => {
                eventSource?.close();
                eventSource = null;
            }, config.closeAfterHiddenFor * 1000);
        } else {
            window.clearTimeout(visibilitychangeTimeoutId);

            if (eventSource === null) {
                openConnection();
            }
        }
    };

    const openConnection = () => {
        if (eventSource !== null) return;

        eventSource = new EventSource(config.url + (streamId ? `?last_stream_id=${streamId}` : ''));

        eventSource.addEventListener('stream-id', streamIdListener);
        eventSource.addEventListener(config.eventName, messageListener);
        eventSource.addEventListener('error', errorListener);
        document.addEventListener('visibilitychange', visibilitychangeListener);
    };

    const closeConnection = () => {
        eventSource.removeEventListener('stream-id', streamIdListener);
        eventSource.removeEventListener(config.eventName, messageListener);
        eventSource.removeEventListener('error', errorListener);
        document.removeEventListener('visibilitychange', visibilitychangeListener);

        eventSource?.close();
        eventSource = null;
    };

    if (eventSource === null) {
        openConnection();
    }

    return {
        get eventSource() {
            return eventSource;
        },
        get streamId() {
            return streamId;
        },
        set streamId(value) {
            streamId = value;
        },
        get messages() {
            return messages;
        },
        clearMessages() {
            messages = [];
        },
        open: openConnection,
        close: closeConnection,
    };
}
